import { render, staticRenderFns } from "./WeitereWichtigeAngaben.vue?vue&type=template&id=042a989e"
import script from "./WeitereWichtigeAngaben.vue?vue&type=script&lang=js"
export * from "./WeitereWichtigeAngaben.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports